import React, { useState } from 'react';
import Style from './media.tailwind';
import { useTranslate } from 'app/translations';
import { Icon, cn } from 'components/lib';

/**
 * @param compact  Small square thumbs for the always-visible context band,
 *                 rather than the wide 4:3 cards.
 * @param hideTitle  The band supplies its own heading.
 */
const TicketAttachment = ({ medias, compact, hideTitle }) => {
    const { _t } = useTranslate();

    if (!medias?.length) return null;

    return (
        <div>
            {!hideTitle && (
                <h3 className={Style.title}>
                    <Icon image="image" size={16} color="currentColor" className="text-text-muted" />
                    {_t('ticket.history.media')}
                </h3>
            )}
            <div className={cn(Style.container, compact && Style.containerCompact)}>
                {medias.map((media, index) => (
                    <MediaThumb key={media.id || index} media={media} compact={compact} />
                ))}
            </div>
        </div>
    );
};

function MediaThumb({ media, compact }) {
    const [failed, setFailed] = useState(false);
    const filePath = media?.file_path
        ? media.file_path.startsWith('https://') || media.file_path.startsWith('http://')
            ? media.file_path
            : 'https://' + media.file_path
        : '';
    const label = media.image?.original_name || media.file_path?.split('/').pop() || 'image';

    if (!filePath || failed) {
        return (
            <div
                className={cn(Style.fallback, compact && Style.fallbackCompact)}
                title={compact ? label : undefined}>
                <Icon
                    image="image"
                    size={compact ? 18 : 32}
                    color="currentColor"
                    className="text-text-muted"
                />
                {!compact && (
                    <span className="line-clamp-2 text-xs text-text-secondary" title={label}>
                        {label}
                    </span>
                )}
            </div>
        );
    }

    return (
        <a
            target="_blank"
            rel="noreferrer"
            href={filePath}
            className={cn(Style.link, compact && Style.linkCompact)}
            title={label}>
            <img
                className={cn(Style.img, compact && Style.imgCompact)}
                src={filePath}
                alt={label}
                loading="lazy"
                onError={() => setFailed(true)}
            />
            <div className={Style.overlay}>
                <Icon image="eye" color="white" size={compact ? 14 : 18} />
            </div>
        </a>
    );
}

export default TicketAttachment;
